module.exports = __webpack_public_path__ + "img/instagram-colored.2d04626c.svg";